import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { StickyHeaderService } from '../../../services/stickyHeaderService/stickyHeader.service';

@Injectable({providedIn: 'root'})
export class ChangeTitle implements ICommunicationEvent {
	constructor(private stickyHeaderService: StickyHeaderService) {}
	
	get eventName(): string {
		return PlatformCommunicationEvents.ChangeTitle;
	}

	async handleEvent(event: any) {
		this.stickyHeaderService.titleChanged$.next({title: event.data.title, logo: event.data.logo, logoFallback: event.data.logoFallback});
	}
}